import { call, put, takeLatest } from "redux-saga/effects";
import { FETCH_REPORT_DATA } from "../store/reports/constants";
import { FetchDataQueryParams, FetchedData } from "../types/pages/Report";
import { 
    fetchDataFail,
    fetchDataLoading,
    fetchDataSuccess
} from "../store/reports/reportReducer";
import { fetchData } from "./api/reports/fetchData";

function* handleFetchData(action: { type: string, payload: FetchDataQueryParams }) {

    try {

        yield put(fetchDataLoading())
        const result: FetchedData = yield call(fetchData, action.payload);
        yield put(fetchDataSuccess(result))

    } catch(error) {
        yield put(fetchDataFail())
    }

}

export default function* reportSaga() {
    yield takeLatest(FETCH_REPORT_DATA, handleFetchData);
}
